"use client"

import { useState } from "react"
import "./FAQ.css"

const FAQ = ({ language = "en" }) => {
  const [openItems, setOpenItems] = useState({})

  const translations = {
    en: {
      title: "Frequently Asked Questions",
      subtitle:
        "Find answers to common questions about Hon. Abubakar Kabir Abubakar and his work for Bichi Federal Constituency",
    },
    ha: {
      title: "Tambayoyin da Ake Yawan Yi",
      subtitle:
        "Nemo amsoshi ga tambayoyin da ake yawan yi game da Hon. Abubakar Kabir Abubakar da aikinsa na mazabar Bichi",
    },
  }

  const faqData = {
    en: [
      {
        question: "Who is Hon. Abubakar Kabir Abubakar?",
        answer:
          "Hon. Abubakar Kabir Abubakar is the representative of Bichi Federal Constituency and Chairman of the House Committee on Appropriations. He has overseen many projects worth billions of Naira in education, healthcare, agriculture, and infrastructure.",
      },
      {
        question: "What major projects has he facilitated in Bichi?",
        answer:
          "He has facilitated road construction, health centers, modern markets, an 18,000-capacity stadium, school renovations, student sponsorships, and empowerment programs for youth and women.",
      },
      {
        question: "What is his role as Chairman of Appropriations Committee?",
        answer:
          "He oversees Nigeria’s federal budget process, ensures fair allocation of funds, and monitors ministries and agencies to ensure proper spending of public resources.",
      },
      {
        question: "Has he supported education in Bichi?",
        answer:
          "Yes. Through the Kabir Abubakar Bichi Foundation and constituency funds, he has sponsored students at Bayero University Kano, provided scholarships locally and abroad, distributed learning materials, and initiated the construction of an E-Library.",
      },
      {
        question: "What improvements in healthcare has he facilitated?",
        answer:
          "He has supported the construction of a Trauma Center at AKTH, renovated hospitals, provided medical equipment, and funded maternal and child health programs.",
      },
      {
        question: "How has he supported youth and women?",
        answer:
          "He launched empowerment schemes with items such as sewing machines, motorcycles, and grants. He also sponsors sports initiatives like Bichi First FC to engage youth positively.",
      },
      {
        question: "How can constituents reach him?",
        answer:
          "You can visit the constituency office in Bichi, contact his Abuja National Assembly office, or reach out via official social media pages. He also hosts town hall meetings.",
      },
      {
        question: "What bills has he sponsored?",
        answer:
          "He sponsored the University of Medicine and Health Sciences Bichi Bill (2021) and the Office of the Surveyor-General of the Federation Bill (2021), among others.",
      },
    ],
    ha: [
      {
        question: "Wanene Hon. Abubakar Kabir Abubakar?",
        answer:
          "Hon. Abubakar Kabir Abubakar shine wakilin mazabar Bichi kuma Shugaban Kwamitin Kasafin Kudi na Majalisar Wakilai. Ya jagoranci ayyuka da dama da suka shafi ilimi, lafiya, noma, da ababen more rayuwa.",
      },
      {
        question: "Wadanne manyan ayyuka ya samar wa Bichi?",
        answer:
          "Ya samar da hanyoyi, cibiyoyin lafiya, kasuwanni na zamani, filin wasa mai kujeru 18,000, gyaran makarantu, tallafawa dalibai, da shirye-shiryen karfafa matasa da mata.",
      },
      {
        question: "Menene aikinsa a matsayin Shugaban Kwamitin Kasafin Kudi?",
        answer:
          "Yana kula da tsarin kasafin kudin kasa, rarraba albarkatu yadda ya kamata, da sa ido kan yadda ma’aikatu da hukumomi ke kashe kudin gwamnati.",
      },
      {
        question: "Shin ya tallafa bangaren ilimi?",
        answer:
          "I, ta hanyar Gidauniyar Kabir Abubakar Bichi da kudaden mazaba, ya dauki nauyin dalibai a Jami’ar Bayero Kano, ya bayar da tallafin karatu a gida da waje, ya rarraba kayan makaranta, tare da fara aikin E-Library a Bichi.",
      },
      {
        question: "Ta yaya ya inganta kiwon lafiya?",
        answer:
          "Ya tallafa wajen gina cibiyar Trauma Center a AKTH, gyaran asibitoci, samar da kayan aiki na likitanci, da shirye-shiryen lafiya ga mata da yara.",
      },
      {
        question: "Ta yaya ya tallafa matasa da mata?",
        answer:
          "Ya bayar da kayan sana’a kamar injinan dinki, babura, da tallafin kudi. Ya kuma tallafa harkar wasanni kamar kungiyar kwallon kafa ta Bichi First FC domin karfafa matasa.",
      },
      {
        question: "Ta yaya mazaba za su iya tuntubarsa?",
        answer:
          "Za a iya ziyartar ofishinsa a Bichi, ofishinsa a Majalisar Tarayya Abuja, ko ta hanyar shafukan sada zumunta. Hakanan yana shirya tarurrukan gama gari don tattaunawa kai tsaye.",
      },
      {
        question: "Wadanne kudurori ya gabatar?",
        answer:
          "Ya gabatar da kudurin kafa Jami’ar Likitanci da Kimiyyar Lafiya ta Bichi (2021) da na Ofishin Surveyor-General na Tarayya (2021), da sauran su.",
      },
    ],
  }

  const t = translations[language]
  const currentFAQs = faqData[language] || faqData.en

  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  return (
    <div className="faq-container">
      <div className="faq-header">
        <h1>{t.title}</h1>
        <p>{t.subtitle}</p>
      </div>

      <div className="faq-list">
        {currentFAQs.map((item, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => toggleItem(index)}>
              <span>{item.question}</span>
              <span className={`faq-toggle ${openItems[index] ? "open" : ""}`}>+</span>
            </div>
            <div className={`faq-answer ${openItems[index] ? "open" : ""}`}>
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FAQ
